import SummaryCards from 'civic-champs-shared/core/SummaryCards'
import React, { useMemo } from 'react'
import { Activity } from 'champion/utils/interface'
import format from 'civic-champs-shared/utils/format'
import { maxBy, reduce } from 'lodash'
import { ProfileNotes } from 'champion/components/ProfileNotes'
import makeStyles from '@material-ui/styles/makeStyles'
import { useNationalAvgVolunteerValuePerHour } from 'champion/hooks/useNationalAvgVolunteerValuePerHour'

const useStyles = makeStyles({
  summaryCards: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
})

export const ProfileOverview = ({
  activities,
  personId,
}: {
  activities: Omit<Activity, 'user' | 'organization'>[]
  personId: number
}) => {
  const classes = useStyles()
  const valuePerHour = useNationalAvgVolunteerValuePerHour()
  const cards = useMemo(
    () => [
      {
        header: 'Activities',
        accessor: 'activities',
        transform: format.number,
      },
      {
        header: 'Hours',
        accessor: 'hours',
        transform: format.number,
      },
      {
        header: 'Last Activity',
        accessor: 'lastActivity',
        transform: format.date,
      },
      {
        header: 'Est. Impact',
        accessor: 'hours',
        transform: (v: number) => format.money(valuePerHour * v),
      },
    ],
    [valuePerHour],
  )
  const summary = {
    activities: activities.length,
    hours: reduce(activities, (total, { hoursVolunteered }) => total + hoursVolunteered, 0),
    lastActivity: maxBy(activities, 'occurredAt')?.occurredAt,
  }
  return (
    <>
      <div className={classes.summaryCards}>
        <SummaryCards cards={cards} data={summary} />
      </div>
      <ProfileNotes personId={personId} />
    </>
  )
}
